import React from 'react';
import { Container, Row, Col } from 'reactstrap';
import ProfileAvatarImg from '../../../components/Profile/ProfileAvatarImg';
import ProfileNav from '../components/ProfileNav/ProfileNav';

const WithProfileNav = WrappedComponent => props => {
  return (
    <Container className="profile-page">
      <h3 className="page-title pb-4 pt-0">Профиль</h3>
      <Row>
        <Col lg="3">
          <ProfileAvatarImg theme={4} />
          <Col lg="10 mx-n3">
            <ProfileNav />
          </Col>
        </Col>
        <Col lg="9">
          <WrappedComponent {...props} />
        </Col>
      </Row>
    </Container>
  );
};

export default WithProfileNav;
